module.exports = __webpack_public_path__ + "lieu travail auteurs.jpg?5ffb2bc5367475f95cf30b692c972955";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lieu travail auteurs.jpg
// module id = 192
// module chunks = 0